import type { ReactNode } from 'react';

/** 额度和来源共用进度条；未知/无限量不伪装成已使用100%。 */
export default function CreditProgress({ label, used, total, unlimited = false, tone = 'blue', detail }: {
  /** 无障碍名称，描述此条额度而非仅给出颜色。 */
  label: string;
  /** 平台原始同单位用量；未知保持null。 */
  used: number | null;
  total: number | null;
  unlimited?: boolean;
  tone?: 'blue' | 'amber' | 'violet' | 'muted';
  /** 已本地化的金额/未知状态，用于读屏及悬浮说明。 */
  detail: ReactNode;
}) {
  const known = !unlimited && used !== null && total !== null && Number.isSafeInteger(used)
    && Number.isSafeInteger(total) && used >= 0 && total > 0;
  const percent = known ? Math.max(0, Math.min(100, used / total * 100)) : 0;
  const colors = { blue: 'bg-blue-500', amber: 'bg-amber-500', violet: 'bg-violet-500', muted: 'bg-gray-400 dark:bg-gray-500' };
  return <div className="min-w-0 space-y-2">
    <div className="flex flex-wrap items-baseline justify-between gap-1 text-xs">
      <span className="font-medium">{label}</span><span className="tabular-nums">{detail}</span>
    </div>
    <div role={known ? 'progressbar' : undefined} aria-label={known ? label : undefined}
      aria-valuemin={known ? 0 : undefined} aria-valuemax={known ? 100 : undefined} aria-valuenow={known ? Math.round(percent) : undefined}
      className="h-1.5 overflow-hidden rounded-full bg-black/[0.06] dark:bg-white/10">
      <div aria-hidden="true" className={`h-full rounded-full motion-safe:transition-[width] motion-safe:duration-300 ${unlimited ? 'bg-[repeating-linear-gradient(135deg,rgba(99,102,241,0.28)_0_4px,transparent_4px_8px)]' : colors[tone]}`}
        style={{ width: `${unlimited ? 100 : percent}%` }} />
    </div>
  </div>;
}
